// extracted by mini-css-extract-plugin
export default {"danger":"VBAlert_danger__afOjZ"};